import React, { useEffect, useState } from "react";
import PayConfBar from "../layout/PayConfirmDetailBar";
import Modal from "react-modal";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";
import { date } from "yup";
import DataTableLayout from "../Modal/DataTableLayout";
import { Columns } from "./CompetitionColumns";
import MOCK_DATA from "./MOCK_DATA.json";
import axios from "axios";
import { BASE_URL } from "../../config.json";
import ENUMS from "../../utils/ENUMS";
import { getAuthData, setAuth } from "../../services/authService";
import moment from "moment";
import { useHistory } from "react-router-dom";
import LogNav from "../layout/LoggedNav";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import DateTimePicker from "../Reusable/DateTimePicker";
import SelectDrop from "../IncidentsLog/SearchDrop";
import { getUserCourses } from "../../services/apiService";

const token = localStorage.getItem(ENUMS.AUTH);
const auth = getAuthData();
const config = {
  headers: { Authorization: `Bearer ${token}` },
};
const validationSchema = yup.object().shape({
  competition_name: yup.string().required("* Required"),
  start_date: date().typeError("Invalid Date!"),

  // .required('* Required')
  // .min(new Date(), 'Please choose future date')
  end_date: date().typeError("Invalid Date!"),
});

const customStyles = {
  overlay: {
    zIndex: "2",
    backgroundColor: "rgba(0,0,0,0.6)",
  },
  content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // width: "50%",
    overflow: "initial",
  },
  breakpoint: {},
};
const customStyles2 = {
  overlay: {
    zIndex: "3",
    backgroundColor: "rgba(0,0,0,0.6)",
  },
  content: {
    position: "absolute",
    top: "30%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40rem",
  },
};

Modal.setAppElement("#root");

const Competition = () => {
  let history = useHistory();
  const [competitionData, setCompetitionData] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modaledit, setModaledit] = useState(false);
  const [modalDel, setModalDel] = useState(false);
  const [delUserData, setDelUserData] = useState();
  const datenew = moment(new Date()).add(1, "minute");
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState();

  const [startDate, setStartDate] = useState(datenew._d);
  const [competitionId, setCompetitionId] = useState();

  const getCourses = () => {
    getUserCourses(token).then((data) => {
      // console.log("get courses",data)
      if (data && data.data?.status === "SUCCESS") {
        setCourses(data.data.data);
        setSelectedCourse(data.data.data[0]?.id);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {}, [competitionData]);
  useEffect(() => {
    getCourses();
  }, []);
  useEffect(() => {
    getdata();
  }, []);

  const getdata = () => {
    axios
      .get(`${BASE_URL}/club/competition_club/${auth.club_id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        // SetHoles(res.data.data);
        setCompetitionData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const postcompetition = (data, showToast = true) => {
    const finalData = {
      golfcourse: selectedCourse,
      name: data.competition_name,
      club: auth.club_id,
      start_date: data.start_date,
      end_date: data.end_date,
    };

    axios
      .post(`${BASE_URL}/club/competition_create/`, finalData, config)
      .then((res) => {
        toast.success("Competition created successfully");
        // openModalRun()
        getdata();
      })
      .catch((err) => {
        console.log(err, "err");
        toast.error(err.response.data.errMsg);
      });
  };

  const postEditCompetition = (data, showToast = true) => {
    const EditFinalData = {
      name: data.competition_name,
      club: auth.club_id,
      start_date: data.start_date,
      end_date: data.end_date,
    };

    axios
      .patch(
        `${BASE_URL}/club/competition/${competitionId}/`,
        EditFinalData,
        config
      )
      .then((res) => {
        toast.success("Competition updated successfully");
        // setmodaledit(false)
        getdata();
      })
      .catch((err) => {
        console.log(err, "err");
        toast.error(err.response.data.errMsg);
      });
  };

  const formik = useFormik({
    initialValues: {
      course_name: "",
      competition_name: "",
      start_date: moment(new Date()).add(1, "minute")._d,
      // moment(new Date())
      //     .add(1, 'd')
      //     .format('YYYY-MM-DD'),

      end_date: moment(new Date()).add(1, "day")._d,
    },
    onSubmit: (values, { resetForm }) => {
      // values.label = values.label.toLowerCase();
      // postIncident(values)
      debugger;
      console.log(values);
      postcompetition(values);
      resetForm();
      // toast.success("Competition created successfully");
      setModalIsOpen(false);
    },
    validationSchema: validationSchema,
  });

  const EditData = useFormik({
    initialValues: {
      competition_name: "",
      start_date: moment(new Date()).add(1, "minute")._d,
      end_date: moment(new Date()).add(1, "day")._d,
    },
    onSubmit: (values, { resetForm }) => {
      // values.label = values.label.toLowerCase();
      // postIncident(values)
      console.log(values, "edited data");
      postEditCompetition(values);
      resetForm();
      // toast.success("Competition created successfully");
      setModaledit(false);
    },
    validationSchema: validationSchema,
  });
  // const EditData = useFormik()
  const renderErrorMessage = (field) => {
    return (
      formik.touched[field] && (
        <div
          style={{
            color: "red",
            position: "absolute",
            left: "5%",
            bottom: "0",
            fontSize: "1.6rem",
          }}
        >
          {formik.errors[field]}
        </div>
      )
    );
  };
  const EditFieldvalidation = (field) => {
    return (
      EditData.touched[field] && (
        <div
          style={{
            color: "red",
            position: "absolute",
            left: "5%",
            bottom: "0",
            fontSize: "1.6rem",
          }}
        >
          {EditData.errors[field]}
        </div>
      )
    );
  };
  const modalHandler = () => {
    setModalIsOpen(false);
    formik.resetForm();
  };
  const openModalRun = () => {
    setModalIsOpen(true);
  };
  const editCompetition = (data) => {
    console.log(data, "data");
    setCompetitionId(data.id);
    EditData.initialValues.competition_name = data.name;
    EditData.initialValues.start_date = data.start_date
      ? new Date(data.start_date)
      : moment(new Date()).add(1, "minute").format("YYYY-MM-DD");
    // EditData.initialValues.start_date=data.start_date
    EditData.initialValues.end_date = data.end_date
      ? new Date(data.end_date)
      : moment(new Date()).add(1, "day").format("YYYY-MM-DD");

    setModaledit(true);
  };
  const deleteCompetition = (data) => {
    console.log(data, "delete");
    setModalDel(true);
    setDelUserData(data.id);
  };
  const chancelEdit = () => {
    setModaledit(false);
    EditData.resetForm();
  };
  const HandleChangeDate = (date) => {
    setStartDate(date);
    formik.setFieldValue("start_date", date);
  };
  console.log(startDate, "startDate");
  const removeComepition = (id) => {
    axios
      .delete(`${BASE_URL}/club/competition/${id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          // setShowModal(false);
          toast.success("Competition Deleted SuccessFully");
          getdata();
        } else {
          toast.error("Unable to  Delete");
        }
      })
      .catch((err) => {
        // alert('Something Wents Wrong Please Give Proper details')
        console.log(err);
      });
    setModalDel(false);
  };

  const renderCell = (cell) => {
    if (cell.column.id === "edit") {
      return (
        <span className="asc__cell cell--edit">
          <img
            src={require("../../assets/edit.svg").default}
            alt=""
            onClick={() => editCompetition(cell.row.original)}
            style={{ cursor: "pointer", width: "2rem" }}
          />

          {cell.render("Cell")}
        </span>
      );
    }

    if (cell.column.id === "delete") {
      return (
        <span className="asc__cell cell--delete">
          <img
            src={require("../../assets/images/del/delete.svg").default}
            alt=""
            onClick={() => deleteCompetition(cell.row.original)}
            style={{ cursor: "pointer" }}
          />
        </span>
      );
    }

    return cell.render("Cell");
  };
  return (
    <section className=" club_Login">
      <div className="page-width">
        <div className="competition gap-block-section">
          <ToastContainer />
          <h1 className="paycourses-title text-jost-sb-50">
          </h1>
          {/* <LogNav /> */}
          <div className="paycourses__wrap">
            <div className="paycourses__box">
              <button
                className="res-btn-primary ml-auto"
                onClick={openModalRun}
              >
                Add Competition
              </button>
              <div className="reports_table">
                {loading ? (
                  <span>Loading Competition...</span>
                ) : (
                  <DataTableLayout
                    showNoResultsMsg
                    noResultsMsgLabel="No Competition!"
                    columns={Columns}
                    data={competitionData}
                    className="asc__dt"
                    renderCell={renderCell}
                  />
                )}
              </div>

              {/*<div className="paycourses-links">*/}
              {/*    <a style={{cursor: "pointer"}} target="_self" onClick={() => {*/}
              {/*        history.push("/loged-user-courses")*/}
              {/*    }} className="paycourses-links-back link-md-gray cursor-pointer">Back to*/}
              {/*        courses</a>*/}
              {/*</div>*/}

              <Modal
                isOpen={modalIsOpen}
                style={customStyles}
                contentLabel="Example Modal"
                className={"custom__modal"}
              >
                <div className="competition__modal competition__modal_custom">
                  <button target="_self" className="modal-content--cross">
                    <img
                      src={
                        require("../../assets/images/cross/Group 6926.svg")
                          .default
                      }
                      alt=""
                      onClick={modalHandler}
                    />
                  </button>
                  <h1 className="text-jost-sb-24">Competition </h1>
                  <form
                    className="competition_form"
                    onSubmit={formik.handleSubmit}
                  >
                    <div className="form_internal">
                      <div className="date_selection">
                        <div className="field_wrap">
                          <span className="text-ops-rg-15-bd">
                            Competition Name
                          </span>

                          <input
                            className="acc__input-lg"
                            type="text"
                            placeholder={"Competition Name"}
                            name="competition_name"
                            {...formik.getFieldProps("competition_name")}
                          />
                          {renderErrorMessage("competition_name")}
                        </div>
                        <div className="field_wrap">
                          <span className="text-ops-rg-15-bd">Course Name</span>

                          <SelectDrop
                            selectedCourse={selectedCourse}
                            style1={false}
                            setSelectedCourse={setSelectedCourse}
                            courses={courses}
                          />
                        </div>
                      </div>
                      <div className="date_selection">
                        <div className="field_wrap">
                          <span className="text-ops-rg-15-bd">Start Date</span>
                          {/*<input*/}
                          {/*    className="acc__input-lg"*/}
                          {/*    type="date"*/}
                          {/*    placeholder={"Start Date"}*/}
                          {/*    name="start_date"*/}
                          {/*    {...formik.getFieldProps('start_date')}*/}

                          {/*/>*/}
                          {/*<DatePicker*/}
                          {/*    className="acc__input-lg"*/}
                          {/*    selected={formik.values.start_date}*/}
                          {/*    onChange={(date) => formik.setFieldValue('start_date',date)}*/}
                          {/*    timeInputLabel="Time:"*/}
                          {/*    dateFormat="MM/dd/yyyy h:mm aa"*/}
                          {/*    name="start_date"*/}
                          {/*    isClearable*/}
                          {/*    showIcon*/}
                          {/*    placeholderText={"Start Date"}*/}
                          {/*    showTimeInput*/}
                          {/*    minDate={moment().add(1,'day').toDate()}*/}
                          {/*/>*/}
                          <DateTimePicker
                            name="start_date"
                            formik={formik}
                            selectDate={formik.values.start_date}
                            label={"Start Date"}
                          />

                          {renderErrorMessage("start_date")}
                        </div>
                        <div className="field_wrap">
                          <span className="text-ops-rg-15-bd">End Date</span>

                          {/*<input*/}
                          {/*    className="acc__input-lg"*/}
                          {/*    type="date"*/}
                          {/*    placeholder={"End Date"}*/}
                          {/*    name="end_date"*/}
                          {/*    {...formik.getFieldProps('end_date')}*/}

                          {/*/>*/}
                          <DateTimePicker
                            name="end_date"
                            formik={formik}
                            selectDate={formik.values.end_date}
                            label={"End Date"}
                          />

                          {renderErrorMessage("end_date")}
                        </div>
                      </div>
                    </div>
                    <button
 className="res-btn-lightgrn"                       type="submit"
                    >
                      Add
                    </button>
                  </form>
                </div>
              </Modal>
            </div>
          </div>

          <Modal
            isOpen={modaledit}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <h2 className=" text-jost-sb-20 txt_capt"> Edit Competition </h2>
            <form
              className="competition_form"
              validation={validationSchema}
              onSubmit={EditData.handleSubmit}
              // validationSchema={FORM_VALIDATION}
            >
              <div className="form_internal">
                <div className="field_wrap">
                  <span className="text-ops-rg-15-bd">Competition Name</span>

                  <input
                    className="acc__input-lg"
                    type="text"
                    placeholder={"Competition Name"}
                    name="competition_name"
                    {...EditData.getFieldProps("competition_name")}
                    // onChange={updateName}
                    // value={Formlist.name}
                  />
                  {EditFieldvalidation("competition_name")}

                  {/*{Formlist.name === '' || Formlist.name === null ? renderErrorMessage('competition_name') : ''}*/}
                </div>
                <div className="date_selection">
                  <div className="field_wrap">
                    <span className="text-ops-rg-15-bd">Start Date</span>
                    {/*<input*/}
                    {/*    className="acc__input-lg"*/}
                    {/*    type="date"*/}
                    {/*    placeholder={"Start Date"}*/}
                    {/*    name="start_date"*/}
                    {/*    {...EditData.getFieldProps('start_date')}*/}
                    {/*    // value={Formlist.start_date}*/}
                    {/*    // onChange={updateStartDate}*/}

                    {/*/>*/}
                    <DateTimePicker
                      name="start_date"
                      formik={EditData}
                      selectDate={EditData.values.start_date}
                      label={"Start Date"}
                    />

                    {/*{Formlist.start_date === '' || Formlist.start_date === null ? renderErrorMessage('start_date') : ''}*/}
                    {EditFieldvalidation("start_date")}
                  </div>
                  <div className="field_wrap">
                    <span className="text-ops-rg-15-bd">End Date</span>

                    <DateTimePicker
                      name="end_date"
                      formik={EditData}
                      selectDate={EditData.values.end_date}
                      label={"End Date"}
                    />

                    {/*{Formlist.end_date === '' || Formlist.end_date === null ? renderErrorMessage('end_date') : ''}*/}
                    {EditFieldvalidation("end_date")}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <button
                  className="res-btn-primary-md"
                  onClick={chancelEdit}
                  type="submit"
                >
                  cancel
                </button>
                <button className="res-btn-lightgrn" type="submit">
                  Save
                </button>
              </div>
            </form>
          </Modal>

          <Modal
            isOpen={modalDel}
            style={customStyles2}
            contentLabel="Example Modal"
          >
            <div className="del_com_modal">
              <button
                className="btn-close_com"
                onClick={() => setModalDel(false)}
              >
                &times;
              </button>
              <h2 className=" text-jost-sb-20">
                {" "}
                Are you sure you want to delete this incident?{" "}
              </h2>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  gap:"0.5rem"
                }}
              >
                <button
 className="res-btn-primary"                  onClick={() => setModalDel(false)}
                >
                  Cancel
                </button>

                <button
 className="res-btn-lightgrn"                  onClick={() => removeComepition(delUserData)}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </section>
  );
};

export default Competition;
